import React from 'react';
export function ButtonGroup({ children, className }) {
    return React.createElement("div", { className: `tw-flex${className ? ` ${className}` : ''}` }, children);
}
export default ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map